import caller from "../../helpers/caller";

/** payload: { id, answers: {...} } */
export default async function postUpdateCustomerQuestionnaire(api, payload) {
  return await caller(api.post, "/customer_questionnaire/update", payload);
}
